import { useApiClient } from '@hetivo/hetivo-lib-front-utils';
import type { PaginatedResponse } from '@hetivo/hetivo-lib-types';
import type { Location } from '@hetivo/hetivo-lib-types';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { createLocationApi, locationKeys } from '../api';
import type { SearchLocationsParams } from '../api';

export interface UseLocationsOptions extends SearchLocationsParams {
  enabled?: boolean;
}

export function useLocations(params: UseLocationsOptions): UseQueryResult<PaginatedResponse<Location>> {
  const { enabled = true, ...searchParams } = params;
  const client = useApiClient('admin-auth');
  const api = createLocationApi(client);

  return useQuery({
    enabled,
    gcTime: 5 * 60_000,
    queryFn: () => api.searchLocations(searchParams),
    queryKey: locationKeys.search(searchParams as Record<string, unknown>),
    staleTime: 30_000,
  });
}
